import React from "react"
import { CardStackWrapper } from "../GameBoardStyled"
import Cards from "./Cards"
import { Credentials } from "./credentials/Credentials"

interface INFO {
  currency: string
  precision: number
}

interface STACK_PROPS {
  name: string
  stake: string
  gameInfo: INFO
  result: string
  cards: string[]
  point?: string
  points?: (string | number)[]
  win?: boolean
  deal?: boolean
  dealOut?: boolean
  isGameActive: boolean
  bankerLength?: number
  showResult: boolean
}

export default function CardStackComponent({
  gameInfo,
  name,
  stake,
  cards,
  result,
  win,
  isGameActive,
  deal,
  point,
  points,
  bankerLength,
  showResult,
  dealOut,
}: STACK_PROPS): JSX.Element {
  const { currency, precision } = gameInfo
  return (
    <CardStackWrapper>
      <Credentials
        isGameActive={isGameActive}
        bankerLength={bankerLength}
        deal={deal}
        stake={stake}
        currency={currency}
        point={point || ""}
        points={points}
        name={name}
        precision={precision}
      />
      <Cards
        cards={cards}
        result={result}
        win={win}
        deal={deal}
        dealOut={dealOut}
        isGameActive={isGameActive}
        name={name}
        bankerLength={bankerLength}
        showResult={showResult}
      />
    </CardStackWrapper>
  )
}
